import { ArticleCard } from '#/components/ui/ArticleCard';
import { CategoryCard } from '#/components/ui/CategoryCard';
import { SectionHeader } from '#/components/ui/SectionHeader';

const FIXED_INCOME_CATEGORY_CARD = {
  eyebrow: 'Search',
  title: 'Fixed Income Security Lookup',
  href: 'https://www.finra.org/finra-data/fixed-income',
  description: 'Search on TRACE symbol or CUSIP to find a security and review details including real-time trade history.'
};

const FIXED_INCOME_ARTICLES = [
  {
    title: 'Basics To Know About Investing in Bonds',
    content:
      'Getting answers to some key questions and making use of some well-established methods of bond evaluation can help you determine if a bond is right for you.',
    href: 'https://www.finra.org/investors/investing/investment-products/bonds',
  },
  {
    title: 'Types of Bonds',
    content:
      'A comprehensive overview on the most common types of bonds, such as Corporate Bonds, Agency Securities, Municipal Bonds, and more.',
    href: 'https://www.finra.org/investors/investing/investment-products/bonds#types',
  },
];

export function FixedIncomeDataSection() {
  return (
    <section
      id="fixed-income-data"
      className="flow flow-inner-20 scroll-mt-(--scroll-offset)"
    >
      <SectionHeader title="Fixed Income Data" headingClassName="leading-tight">
        <p className="text-fg-muted text-fluid-base-sm leading-relaxed">
          Learn more about Bonds through FINRA&apos;s Fixed Income Data.
        </p>
      </SectionHeader>

      <div className="grid gap-20 lg:grid-cols-3">
        <CategoryCard
          eyebrow={FIXED_INCOME_CATEGORY_CARD.eyebrow}
          title={FIXED_INCOME_CATEGORY_CARD.title}
          href={FIXED_INCOME_CATEGORY_CARD.href}
          target="_blank"
          rel="noopener noreferrer"
          icon="search"
          iconSize={16}
          description={FIXED_INCOME_CATEGORY_CARD.description}
          dataTrack="home_fixed_income_card"
          dataTrackLabel={FIXED_INCOME_CATEGORY_CARD.title}
          dataTrackContext="fixed_income"
        />

        {FIXED_INCOME_ARTICLES.map((article) => (
          <ArticleCard
            key={article.title}
            title={article.title}
            content={article.content}
            href={article.href}
            headingLevel="h3"
            target="_blank"
            rel="noopener noreferrer"
            dataTrack="home_fixed_income_article"
            dataTrackLabel={article.title}
            dataTrackContext="fixed_income"
          />
        ))}
      </div>
    </section>
  );
}
